import React from "react"

const Footer = () => {
  return (
    <footer>
      <div className="social">
        <h3>social</h3>
        <button>Newsletter Sign Up</button>
      </div>
      <div className="features">
        <h3>features</h3>
        <div>
          <a href="https://www.giant-bicycles.com/gb">news</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">events</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">technology</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">team &amp; riders</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">find a giant retailer</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">wallpapers</a>
        </div>
      </div>
      <div className="support">
        <h3>support</h3>
        <div>
          <a href="contacts.html">contact</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">
            helmet crash replacement
          </a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">bike archive</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">newsletter</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">register your bike</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">
            terms &amp; conditions of sale
          </a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">home delivery</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">
            returns &amp; cancellations procedure
          </a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">
            competition terms &amp; conditions
          </a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">giant cycle to work</a>
        </div>
      </div>
      <div className="company">
        <h3>company</h3>
        <div>
          <a href="https://www.giant-bicycles.com/gb">about giant bicycles</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">privacy policy</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">cookie policy</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">job openings</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">global website</a>
        </div>
        <div>
          <a href="https://www.giant-bicycles.com/gb">
            modern slavery statement
          </a>
        </div>
      </div>
      <div className="address">
        <p>
          Giant UK &verbar; Charnwood Edge &verbar; Cossington &verbar; LE7 4UZ
          GB &verbar; 0800 0159 110 &verbar; webshop@giant-bicycles.co.uk
        </p>
      </div>
    </footer>
  )
}

export default Footer
